import { formatDateTime } from "../../../utils/format";

export default function HospitalMemberTable({ data }) {
  const table = {
    header: [
      {
        id: 1,
        title: "번호",
      },
      {
        id: 2,
        title: "구분",
      },
      {
        id: 3,
        title: "가입유형",
      },
      {
        id: 4,
        title: "아이디(이메일주소)",
      },
      {
        id: 5,
        title: "담당자 연락처",
      },
      {
        id: 6,
        title: "가입일시",
      },
      {
        id: 7,
        title: "관리",
      },
    ],
  };

  const renderRole = (role) => {
    switch (role) {
      case "NOT_IN_CHARGE":
        return "미담당";
      case "REPRESENTATIVE_ACCOUNT":
        return "담당자";

      default:
        break;
    }
  };

  const renderType = (type) => {
    switch (type) {
      case "NURSE":
        return "간호사";
      case "DOCTOR":
        return "의사";

      default:
        break;
    }
  };

  return (
    <>
      <div className="w-full block whitespace-nowrap overflow-auto">
        <table className="w-full text-center">
          <thead>
            <tr className="border border-[#dddddd]" key={0}>
              {table.header.map((val) => (
                <th
                  className="p-2 bg-[#f2f2f4] border border-[#dddddd]"
                  key={val.id}
                >
                  {val.title}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data?.map((val, idx) => (
              <tr
                key={
                  val?.id ??
                  val?.hospitalMemberId ??
                  (val?.email != null ? String(val.email) : idx)
                }
              >
                <td className="p-3 border border-[#dddddd]">{idx + 1}</td>
                <td className="p-3 border border-[#dddddd]">
                  {renderRole(val?.role)}
                </td>
                <td className="p-3 border border-[#dddddd]">
                  {renderType(val?.type)}
                </td>
                <td className="p-3 border border-[#dddddd]">{val?.email}</td>
                <td className="p-3 border border-[#dddddd]">{val?.phone}</td>
                <td className="p-3 border border-[#dddddd]">
                  {val?.createdAt ? formatDateTime(val?.createdAt) : ""}
                </td>

                <td className="p-3 border border-[#dddddd]">
                  <div className="flex gap-2 justify-center items-center">
                    MANAGEMENT - BE PENDING
                    {/* <span className="px-2 py-1 border border-[#0f1e3d] bg-[#0f1e3d] rounded-[4px] text-[#ffffff]">
                        대표 계정
                      </span>
                      <span className="px-2 py-1 border border-[#0055ff] rounded-[4px] text-[#0055ff]">
                        담당 지정
                      </span> */}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
